import { CoopCollection } from '@aipb/personal-content/shared/model';
import { CollectionLabelComponent, NibbleTypeIconComponent } from '@aipb/personal-content/ui';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pc-message-collection-list',
  imports: [CollectionLabelComponent, MatIconModule, NibbleTypeIconComponent, TranslocoPipe],
  templateUrl: './message-collection-list.component.html',
  styleUrls: ['./message-collection-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageCollectionListComponent {
  @Input() collections: CoopCollection[] = [];
  // @ts-expect-error foo
  @Input() collectionId: string;
  // @ts-expect-error foo
  @Input() userId: string;

  @Output() sendMessageToCollection = new EventEmitter<string>();
  @Output() openCollection = new EventEmitter<string>();
  @Output() openCollectionInTab = new EventEmitter<string>();
}
